import type { ApiSchemas } from '@provisium/web-api'

import { apiRequest } from './client'
import { demoChatPartners } from '../dev/buyerDemoData'
import { withDemoUi } from '../dev/demoMode'

export type ChatPartner = {
  organizationId: number
  /** Organization legal name (e.g. ООО «Нова»). */
  name: string
}

// Формы провода — из контракта (генерируются из openapi.json по коду бэкенда).
// Раньше они были описаны здесь руками и разошлись с бэкендом: покупатель на проводе
// зовётся buyer* с коммита 2aa43db, а тут читали restaurant* — organizationId молча
// становился 0. camelCase-часть — совместимость до раскатки snake в прод (шаг 4).
type SupplierItem = ApiSchemas['MySupplierDto'] & {
  supplierOrganizationId?: number
  supplierName?: string | null
}
type CustomerItem = ApiSchemas['MyCustomerDto'] & {
  buyerOrganizationId?: number
  buyerName?: string | null
}

type MySuppliersPage = Omit<ApiSchemas['MySuppliersPageDto'], 'items'> & { items?: SupplierItem[] }
type MyCustomersPage = Omit<ApiSchemas['MyCustomersPageDto'], 'items'> & { items?: CustomerItem[] }

const partnerLegalName = (
  legalName: string | null | undefined,
  fallbackName: string | null | undefined,
  orgId: number,
  kind: 'supplier' | 'buyer',
): string => {
  const label = legalName?.trim() || fallbackName?.trim()
  if (label) {
    return label
  }
  return kind === 'supplier' ? `Поставщик #${orgId}` : `Покупатель #${orgId}`
}

export const listChatPartners = async (
  organizationId: number,
  role: 'buyer' | 'supplier',
): Promise<ChatPartner[]> =>
  withDemoUi(role === 'buyer' ? demoChatPartners : [], async () => {
  if (role === 'supplier') {
    const page = await apiRequest<MyCustomersPage>(
      `/supplier/customers/my?organizationId=${organizationId}&page=0&size=50`,
    )
    return (page.items ?? []).map((item) => {
      const orgId = item.buyerOrganizationId ?? item.buyer_organization_id ?? 0
      return {
        organizationId: orgId,
        name: partnerLegalName(item.legal_name, item.buyerName ?? item.buyer_name, orgId, 'buyer'),
      }
    })
  }

  const page = await apiRequest<MySuppliersPage>(
    `/buyer/suppliers/my?organizationId=${organizationId}&page=0&size=50`,
  )
  return (page.items ?? []).map((item) => {
    const orgId = item.supplierOrganizationId ?? item.supplier_organization_id ?? 0
    return {
      organizationId: orgId,
      name: partnerLegalName(item.legal_name, item.supplierName ?? item.supplier_name, orgId, 'supplier'),
    }
  })
})
